var e = e || {},
    dv = dv || {},
    pdfMake = pdfMake || {};
( function () {
    'use strict';
    jQuery( function () {
        dv.init();
    } );
    dv.init = function () {
        dv.swipe();
        dv.search();
        dv.datepicker();
        dv.usermanagement.init();
        dv.generators.init();
    };
    dv.swipe = function () {
        jQuery( '.dv-table-container' ).on( 'swipeleft', function () {
            jQuery( 'img.dv-swipe-left' ).fadeOut();
        } );
    };
    dv.search = function () {
        jQuery( '.js-dv-open-search' ).on( 'click', function () {
            if ( jQuery( '.dv-vejning-filters' ).hasClass( 'js-dv-vejning-filters-closed' ) ) {
                jQuery( '.dv-vejning-filters' ).addClass( 'js-dv-vejning-filters-open' ).removeClass( 'js-dv-vejning-filters-closed' ).show();
                jQuery( '.js-dv-part-close-search' ).show();
                jQuery( '.js-dv-part-open-search' ).hide();
            }
            else {
                jQuery( '.dv-vejning-filters' ).addClass( 'js-dv-vejning-filters-closed' ).removeClass( 'js-dv-vejning-filters-open' ).hide();
                jQuery( '.js-dv-part-close-search' ).hide();
                jQuery( '.js-dv-part-open-search' ).show();
            }
        } );
        jQuery( '.js-dv-reset-search' ).on( 'click', function () {
            jQuery( '.js-dv-search-weighings' ).find( 'input' ).val( '' );
        } );
        jQuery( '.js-dv-weighing-filter-help' ).find( '.js-dv-weighing-filter-help-link' ).on( 'click', function () {
            if ( jQuery( this ).closest( '.js-dv-weighing-filter-help' ).find( '.js-dv-weighing-filter-help-box' ).hasClass( 'closed' ) ) {
                jQuery( this ).closest( '.js-dv-weighing-filter-help' ).find( '.js-dv-weighing-filter-help-box' ).addClass( 'open' ).removeClass( 'closed' );
            }
            else {
                jQuery( this ).closest( '.js-dv-weighing-filter-help' ).find( '.js-dv-weighing-filter-help-box' ).addClass( 'closed' ).removeClass( 'open' );
            }
        } );
    };
    dv.datepicker = function () {
        jQuery( '#dateFrom, #dateTo' ).datepicker( {
            dateFormat: 'dd-mm-yy'
        } );
    };
    dv.usermanagement = {
        logoUpload: function () {
            jQuery( '.js-user-logo-upload-button' ).on( 'click', function () {
                jQuery( '.js-user-logo-upload-input' ).trigger( 'click' );
            } );
            jQuery( '.js-user-logo-upload-input' ).on( 'change', function () {
                var input = this;
                if ( input.files && input.files[ 0 ] ) {
                    var reader = new FileReader();
                    reader.onload = function ( e ) {
                        jQuery( '.js-user-logo-upload-preview' ).attr( 'src', e.target.result ).show();
                    };
                    reader.readAsDataURL( input.files[ 0 ] );
                }
            } );
        },
        init: function () {
            this.logoUpload();
        }
    };
    dv.generators = {
        data: {
            excel: [],
            pdf: []
        },
        utils: {
            getDataUri: function ( url, callback ) {
                var image = new Image();
                image.onload = function () {
                    var canvas = document.createElement( 'canvas' );
                    canvas.width = this.naturalWidth;
                    canvas.height = this.naturalHeight;
                    canvas.getContext( '2d' ).drawImage( this, 0, 0 );
                    callback( canvas.toDataURL( 'image/png' ) );
                };
                image.src = url;
            },
            getAllPages: function ( callback ) {
                jQuery.get( location.href, {
                    pagesize: 100000
                }, function ( html ) {
                    var jHtml = jQuery.parseHTML( html );
                    eval( jQuery( jHtml ).find( '#generator-pdf-data' ).html() );
                    eval( jQuery( jHtml ).find( '#generator-excel-data' ).html() );
                    if ( callback ) {
                        callback();
                    }
                } );
            },
            calcSize: function ( size, intToCalc ) {
                var sizeObj = {
                    A4: 100,
                    A5: 71
                };
                var calcPct = sizeObj[ size ],
                    a = intToCalc / 100,
                    b = a * calcPct;
                return b;
            },
            truncate: function ( str, length, doTrunc ) {
                if ( doTrunc && str.length > length ) {
                    var returnStr = str.substring( 0, length ) + '...';
                    return returnStr;
                }
                else {
                    return str;
                }
            },
            loader: function ( show ) {
                if ( show ) {
                    jQuery( '.pdf-loader' ).fadeIn();
                }
                else {
                    jQuery( '.pdf-loader' ).fadeOut();
                }
            }
        },
        excel: {
            options: {
                name: 'Vejninger',
                userName: '',
                filename: '',
            },
            handleInput: function () {
                jQuery( '.js-excel-generator-generate' ).on( 'click', function () {
                    dv.generators.excel.loadResources();
                } );
            },
            loadResources: function () {
                jQuery.ajax( {
                    url: '/Files/Templates/Designs/danvaegt/assets/js/vendor/excel.js',
                    dataType: 'script',
                    beforeSend: dv.generators.utils.loader( true ),
                    cache: true
                } ).done( function () {
                    jQuery.ajax( {
                        url: '/Files/Templates/Designs/danvaegt/assets/js/vendor/blob.js',
                        dataType: 'script',
                        cache: true
                    } ).done( function () {
                        jQuery.ajax( {
                            url: '/Files/Templates/Designs/danvaegt/assets/js/vendor/filesaver.js',
                            dataType: 'script',
                            cache: true
                        } ).done( function () {
                            jQuery.ajax( {
                                url: '/Files/Templates/Designs/danvaegt/assets/js/vendor/jquery.table2excel.js',
                                dataType: 'script',
                                cache: true
                            } ).done( function () {
                                dv.generators.excel.prepareBuild();
                            } );
                        } );
                    } );
                } );
            },
            prepareBuild: function () {
                dv.generators.utils.getAllPages( dv.generators.excel.build );
            },
            build: function () {
                var jData = dv.generators.data.excel,
                    jContainer = jQuery( '#generator-table-excel' ),
                    jTable = '<table class="js-generator-datatable-excel">';
                jTable += '<tr>';
                for ( var i = 0; i < jData.headers.length; i++ ) {
                    jTable += '<td>' + jData.headers[ i ] + '</td>';
                }
                jTable += '</tr>';
                for ( var y = 0; y < jData.entries.length; y++ ) {
                    jTable += '<tr>';
                    for ( var x = 0; x < jData.entries[ y ].length; x++ ) {
                        jTable += '<td>' + jData.entries[ y ][ x ] + '</td>';
                    }
                    jTable += '</tr>';
                }
                jTable += '</table>';
                jContainer.html( jTable );
                dv.generators.excel.create();
            },
            create: function () {
                /*
                jQuery( '.js-generator-datatable-excel' ).table2excel( {
                    exclude: '.noExl',
                    name: dv.generators.excel.options.name,
                    filename: dv.generators.excel.options.filename || dv.generators.excel.options.name,
                    fileext: '.xls',
                    exclude_img: true,
                    exclude_links: true,
                    exclude_inputs: true
                } );
                */
                jQuery( '.js-generator-datatable-excel' ).tableExport( {
                    bootstrap: false,
                    formats: [ 'xls' ],
                    fileName: dv.generators.excel.options.filename || dv.generators.excel.options.name + ( dv.generators.data.user.name !== '' ? '-' + dv.generators.data.user.name.replace( / /g, '_' ) : '' )
                } );
                setTimeout( function () {
                    jQuery( '.js-generator-datatable-excel' ).find( 'button' ).trigger( 'click' );
                }, 500 );
                dv.generators.utils.loader( false );
            },
            init: function () {
                dv.generators.excel.handleInput();
            }
        },
        pdf: {
            options: {
                name: 'Vejninger',
                size: 'A4',
                maxPagesPerPDF: 40,
                maxRowsPerPage: 22,
                maxEntriesPerPDF: 880,
                fillColors: {
                    default: '#f1f1f1',
                    alternate: '#e1e1e1'
                }
            },
            temp: {
                rowsIndex: 0,
                pageIndex: 0
            },
            data: {
                logo: '/Files/Templates/Designs/danvaegt/assets/img/logo-danvaegt.jpg',
            },
            handleInput: function () {
                jQuery( '.js-pdf-generator-generate' ).on( 'click', function () {
                    dv.generators.pdf.loadResources();
                } );
            },
            loadResources: function () {
                jQuery.ajax( {
                    url: '/Files/Templates/Designs/danvaegt/assets/js/vendor/pdfmake.js',
                    dataType: 'script',
                    beforeSend: dv.generators.utils.loader( true ),
                    cache: true
                } ).success( function () {
                    jQuery.ajax( {
                        url: '/Files/Templates/Designs/danvaegt/assets/js/vendor/vfs_fonts.js',
                        dataType: 'script',
                        cache: true
                    } ).success( function () {
                        dv.generators.pdf.prepareBuild();
                    } );
                } );
            },
            prepareBuild: function () {
                var jImage = dv.generators.pdf.data.logo;
                if ( dv.generators.data.user.image !== '' ) {
                    var testExtension = dv.generators.data.user.image.split( '.' );
                    if ( testExtension[ testExtension.length - 1 ].match( /(jpg|jpeg|png|gif|bmp|svg)/ ) ) {
                        jImage = dv.generators.data.user.image;
                    }
                }
                dv.generators.utils.getDataUri( jImage, function ( dataUri ) {
                    dv.generators.pdf.data.logo = dataUri;
                    dv.generators.utils.getAllPages( dv.generators.pdf.build );
                } );
            },
            calcTotalSum: function ( calcArr, calcIndex ) {
                var total = 0;
                for ( var i = 0; i < calcArr.length; i++ ) {
                    total += parseInt( calcArr[ i ][ calcIndex ] );
                }
                return total.toString();
            },
            build: function () {
                var jPdf = [],
                    jData = dv.generators.data.pdf,
                    jOptions = dv.generators.pdf.options,
                    jHeader = {},
                    jTable = [];
                ///HEADER///
                jHeader = [ {
                    margin: [ 0, 0, 0, 15 ],
                    columns: [ jOptions.name + ( dv.generators.data.user.name !== '' ? ' - ' + dv.generators.data.user.name : '' ), {
                        image: dv.generators.pdf.data.logo,
                        width: dv.generators.utils.calcSize( jOptions.size, 30 )
                    } ]
                } ];
                ///TABLE///
                var jTableBody = [],
                    jTableHeader = [],
                    jTableFooter = [];
                for ( var i = 0; i < jData.headers.length; i++ ) {
                    var jTableHeaderCell = {
                        text: jData.headers[ i ],
                        margin: 2,
                        style: {
                            fontSize: 7,
                            fillColor: '#ffffff',
                        }
                    };
                    jTableHeader.push( jTableHeaderCell );
                }
                jTableBody.push( jTableHeader );
                for ( var y = 0; y < jData.entries.length; y++ ) {
                    var jFillColor = jOptions.fillColors.default;
                    if ( y % 2 === 0 ) {
                        jFillColor = jOptions.fillColors.alternate;
                    }
                    var jTableRow = [];
                    for ( var x = 0; x < jData.entries[ y ].length; x++ ) {
                        var jTableCell = {
                            text: dv.generators.utils.truncate( jData.entries[ y ][ x ], jData.headers[ x ].length, jData.truncate[ x ] ),
                            margin: 2,
                            style: {
                                fontSize: 7,
                                fillColor: jFillColor,
                            }
                        };
                        jTableRow.push( jTableCell );
                    }
                    jTableBody.push( jTableRow );
                    //Check if multiple PDFs should be generated
                    //if ( jData.entries.length > jOptions.maxEntriesPerPDF ) {
                    //Update page-index / rows-index
                    //    if ( y % jOptions.maxRowsPerPage === 0 ) {
                    //        dv.generators.pdf.temp.pageIndex++;
                    //        dv.generators.pdf.temp.rowsIndex = (y + 1);
                    //    }
                }
                for ( var f = 0; f < jData.calculate.length; f++ ) {
                    var jTableFooterCell = {
                        text: jData.calculate[ f ] === true ? dv.generators.pdf.calcTotalSum( jData.entries, f ) : f === 0 ? 'Total: ' : '',
                        margin: 2,
                        style: {
                            fontSize: 7,
                            bold: true,
                            fillColor: '#cccccc'
                        }
                    };
                    jTableFooter.push( jTableFooterCell );
                }
                jTableBody.push( jTableFooter );
                jTable = [ {
                    table: {
                        headerRows: 1,
                        widths: jData.widths,
                        body: jTableBody
                    },
                    layout: 'lightHorizontalLines',
                    margin: [ 0, 0, 0, 10 ]
                } ];
                jTable.margin = [ 0, 0, 0, 20 ];
                jPdf.push( jHeader, jTable );
                dv.generators.pdf.create( jPdf, jOptions );
                //if(dv.generators.pdf.temp.rowsIndex < jData.entries.length){
                //    //Rerun the build sequence from current index
                //}
            },
            create: function ( jPdf, jOptions ) {
                var pdfSheet = {
                    pageSize: jOptions.size,
                    pageOrientation: 'landscape',
                    pageMargins: 30,
                    footer: function ( currentPage, pageCount ) {
                        return {
                            alignment: 'center',
                            text: 'Side: ' + currentPage.toString() + ' af ' + pageCount,
                            fontSize: 8,
                            margin: [ 0, 10, 0, 0 ]
                        };
                    },
                    content: jPdf,
                    styles: {
                        header: {
                            fontSize: 26,
                            bold: true,
                            alignment: 'left'
                        },
                        subheader: {
                            bold: true,
                        },
                        small: {
                            fontSize: 8
                        },
                        copy: {
                            fontSize: 10,
                        }
                    }
                };
                pdfMake.createPdf( pdfSheet ).download( jOptions.name + ( dv.generators.data.user.name !== '' ? '-' + dv.generators.data.user.name.replace( / /g, '_' ) : '' ) + '.pdf' );
                pdfMake.createPdf( pdfSheet ).getDataUrl( function () {
                    dv.generators.utils.loader( false );
                } );
            },
            reset: function () {
                dv.generators.pdf.temp.rowsIndex = 0;
                dv.generators.pdf.temp.pageIndex = 0;
            },
            init: function () {
                eval( jQuery( '#generator-user-data' ).html() );
                this.handleInput();
            }
        },
        init: function () {
            this.excel.init();
            this.pdf.init();
        }
    };
}() );
